import { useEffect, useState } from "react";
import axios from "axios";
import LightAdmin from "components/headers/lightAdmin";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ReactPaginate from "react-paginate";
import './style.css';

const Retraite = () => {
    const [withdrawals, setWithdrawals] = useState([]);
    const [currentPage, setCurrentPage] = useState(0); // Track the current page
    const [totalPages, setTotalPages] = useState(0); // Total pages for pagination
    const token = localStorage.getItem("authToken");

    useEffect(() => {
        fetchWithdrawals();
    }, [currentPage]); // Fetch withdrawals when page changes

    if (!token) {
        console.error("JWT token not found");
        return;
    }
const fetchWithdrawals = async () => {
    try {
        const response = await axios.get(`https://hbmdijital.online/api/withdrawals?page=${currentPage + 1}`, { // Fixed the template literal
            headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 200) {
            setWithdrawals(response.data.data); // Assuming data is in 'data' field
            setTotalPages(response.data.total_pages); // Assuming total pages are returned in 'total_pages'
        } else {
            console.error("Failed to fetch withdrawals:", response.statusText);
        }
    } catch (error) {
        console.error("Error fetching withdrawals:", error);
    }
};
    const approveWithdrawal = async (id, role) => {
        try {
            let url = '';
            let method = '';
    
            // Define URL and HTTP method based on the role
            if (role === 'buyer') {
                url = `https://hbmdijital.online/api/admin/buyer/approve-withdrawal/${id}`;
                method = 'PUT';  // Use PUT for buyers
            } else {
                url = `https://hbmdijital.online/api/admin/withdrawals/${id}/approve`;
                method = 'POST';  // Use POST for suppliers
            }
    
            const response = await axios({
                method: method, // Use dynamic method
                url: url,
                headers: { Authorization: `Bearer ${token}` },
            });
    
            if (response.status === 200) {
                fetchWithdrawals(); // Refresh withdrawals after approval
            } else {
                console.error("Échec de l'approbation :", response.statusText);
            }
        } catch (error) {
            console.error("Erreur lors de l'approbation :", error);
        }
    };

    // Handle page change for pagination
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex flex-column">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        <h1 className="text-dark display-4">Retraite</h1>
                    </div>
                    <hr className="my-4" />

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>Utilisateur</th>
                                    <th>Nom</th>
                                    <th>Téléphone</th>
                                    <th>Montant</th>
                                    <th>Role</th>
                                    <th>Statut</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {withdrawals.map((w) => (
                                    <tr key={w.id}>
                                        <td>{w.user.custom_id}</td>
                                        <td>{w.user.name}</td>
                                        <td>{w.user.phone}</td>
                                        <td>{w.amount} DH</td>
                                        <td>{w.user.role}</td>

                                        <td>{w.status}</td>
                                        <td>
                                            {w.status === "en attente" && (
                                                <button 
                                                    onClick={() => approveWithdrawal(w.id, w.user.role)} 
                                                    className="btn btn-success">
                                                    Approuver
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex justify-content-center mt-4">
                        <ReactPaginate
                            previousLabel={"«"}
                            nextLabel={"»"}
                            breakLabel={"..."}
                            pageCount={totalPages} // Make sure this is set correctly
                            onPageChange={handlePageChange}
                            containerClassName={"pagination justify-content-center"}
                            activeClassName={"active"}
                            disabledClassName={"disabled"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                        />
                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default Retraite;
